import React, { useState, useEffect } from "react";
import { useBluelagoon } from "@bluelagoon";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Upload, Users, Link2 } from "lucide-react";
import ShareUrlCopyField from "./ShareUrlCopyField";
import PublishBlueprintModal from "./PublishBlueprintModal";

export default function BlueprintAuthorCard({ blueprint }) {
    const { t } = useTranslation();
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [currentBlueprint, setCurrentBlueprint] = useState(blueprint);
    const { call: getSubscribers, data: subscriberData } = useBluelagoon({
        method: "getBlueprintSubscribers",
    });

    useEffect(() => {
        if (blueprint?.id) getSubscribers({ id: blueprint.id });
    }, [blueprint?.id]);

    const shareUrl = currentBlueprint?.shareToken
        ? `${window.location.origin}/blueprints/share/${currentBlueprint.shareToken}`
        : null;

    const handlePublished = (result) => {
        setCurrentBlueprint((prev) => ({
            ...prev,
            publishedVersion: result.version,
        }));
        getSubscribers({ id: currentBlueprint.id });
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 space-y-3">
            <div className="flex items-center gap-2">
                <Link2 className="w-4 h-4 text-blue-600" />
                <h3 className="text-sm font-semibold">{t("blueprints.author.title")}</h3>
                <Badge variant="secondary" className="ml-auto">
                    v{currentBlueprint?.publishedVersion || 0}
                </Badge>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Users className="w-4 h-4" />
                <span>
                    {t("blueprints.author.subscriberCount", {
                        count: subscriberData?.data?.total || 0,
                    })}
                </span>
            </div>
            {shareUrl && <ShareUrlCopyField url={shareUrl} />}
            <Button onClick={() => setShowPublishModal(true)} className="w-full" size="sm">
                <Upload className="w-4 h-4 mr-2" />
                {t("blueprints.publish.publishButton")}
            </Button>
            <PublishBlueprintModal
                open={showPublishModal}
                onOpenChange={setShowPublishModal}
                blueprint={currentBlueprint}
                onPublished={handlePublished}
            />
        </div>
    );
}
